import { convertExperiments } from "../services/Convert";
import * as React from "react";

export function useExperiment(experimentId: string) {
  const [variationId, setVariationId] = React.useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    let isMounted = true;

    const loadExperiment = async () => {
      try {
        // Trigger the experiment
        convertExperiments.triggerExperiment(experimentId);

        // Wait for experiment data
        const variation = await convertExperiments.waitForExperimentData(experimentId);

        if (isMounted) {
          setVariationId(variation);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error loading experiment:", error);
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    // Only run on client side
    if (typeof window !== "undefined") {
      loadExperiment();
    } else {
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [experimentId]);

  return { variationId, isLoading };
}
